export default __webpack_public_path__ + "static/media/weixin-cash.2f4c426f.png";